import React, { useCallback, useState } from "react";

import { useMotionBudget } from "../../hooks/useMotionBudget";

import { CurtainCover } from "./CurtainCover";
import { Footlights, StageBackdrop } from "./StageBackdrop";
import {
    CURTAIN_DURATION_MS,
    CURTAIN_DURATION_REDUCED_MS,
    STAGE_BACKGROUND,
    STAGE_COPY,
    STAGE_CREAM
} from "./stageTokens";

/**
 * Màn mở đầu của photobooth: rèm nhung đóng với tấm biển + ảnh quầy chụp. Bấm
 * "Lưu giữ kỷ niệm" là vào thẳng màn chọn khung ảnh ngay.
 */
export function StageIntro({ coverTitle, receiverName, onStart }) {
    const copy = STAGE_COPY;
    const budget = useMotionBudget();
    const [open, setOpen] = useState(false);

    const receiver = receiverName?.trim() || copy.receiverFallback;
    const title = coverTitle?.trim() || copy.coverTitle;

    // Bấm nút: kéo rèm mở, chờ hết animation rồi mới vào màn chọn khung.
    const handleOpen = useCallback(() => {
        if (open) return;
        setOpen(true);
        const wait = budget.reduced
            ? CURTAIN_DURATION_REDUCED_MS
            : CURTAIN_DURATION_MS;
        setTimeout(() => onStart?.(), wait);
    }, [open, budget.reduced, onStart]);

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 1000,
                overflow: "hidden",
                // Rèm mở xong thì cho bấm xuyên xuống Photobooth phía dưới.
                pointerEvents: open ? "none" : "auto"
            }}
        >
            <div
                style={{
                    position: "relative",
                    display: "flex",
                    height: "100%",
                    width: "100%",
                    alignItems: "stretch",
                    justifyContent: "center",
                    overflow: "hidden",
                    color: STAGE_CREAM,
                    // Khi rèm vén ra, bỏ nền sân khấu để lộ màn chọn khung phía sau.
                    background: open ? "transparent" : STAGE_BACKGROUND
                }}
            >
                {!open && <StageBackdrop budget={budget} />}
                {!open && <Footlights />}

                <CurtainCover
                    open={open}
                    title={title}
                    receiver={receiver}
                    onOpen={handleOpen}
                    reduced={budget.reduced}
                    copy={copy}
                />
            </div>
        </div>
    );
}

export default StageIntro;
